// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSKantanIconButtonAnchor_button--default__7AvsH","icon-wrapper":"RSKantanIconButtonAnchor_icon-wrapper___OnuN","spin":"RSKantanIconButtonAnchor_spin__xWYbX"};